import { ocapiV1Routes } from '../routes';
export const ordersApiRoutes = {
    cancel: (orderId) => `${ocapiV1Routes.orders}/${orderId}`,
    getById: (orderId) => `${ocapiV1Routes.orders}/${orderId}`,
    resetExpiry: (orderId) => `${ocapiV1Routes.orders}/${orderId}/expiry-reset`,
    completed: {
        getById: (orderId) => `${ocapiV1Routes.completedOrders}/${orderId}`,
        getByJourneyReference: (journeyReference) => `${ocapiV1Routes.completedOrders}/by-journey-reference/${journeyReference}`,
        getByBookingId: (siteId, bookingId) => `${ocapiV1Routes.completedOrders}/sites/${siteId}/by-booking-id/${bookingId}`,
        swapSeats: (orderId, showtimeId) => `${ocapiV1Routes.completedOrders}/${orderId}/showtimes/${showtimeId}/seats`,
        getIdentifiersForJourneyReference: (journeyReference) => `${ocapiV1Routes.completedOrders}/by-journey-reference/${journeyReference}/identifiers`,
        startOrderPreparation: (orderId) => `${ocapiV1Routes.completedOrders}/${orderId}/preparation`,
        prepareAllItemDeliveries: (orderId) => `${ocapiV1Routes.completedOrders}/${orderId}/item-deliveries/preparation`,
        prepareItemDelivery: (orderId, itemDeliveryId) => `${ocapiV1Routes.completedOrders}/${orderId}/item-deliveries/${itemDeliveryId}/preparation`,
        getPrintStreams: (orderId) => `${ocapiV1Routes.completedOrders}/${orderId}/print-streams`,
        setAsCollected: (orderId) => `${ocapiV1Routes.completedOrders}/${orderId}/collection-status/collected`
    },
    completion: {
        create: (orderId) => `${ocapiV1Routes.orders}/${orderId}/completion`,
        get: (orderId) => `${ocapiV1Routes.orders}/${orderId}/completion`
    },
    create: {
        standard: () => `${ocapiV1Routes.orders}/standard/booking`,
        giftShop: () => `${ocapiV1Routes.orders}/gift-shop`,
        subscription: () => `${ocapiV1Routes.orders}/subscription`
    },
    customer: {
        get: (orderId) => `${ocapiV1Routes.orders}/${orderId}/customer`,
        set: (orderId) => `${ocapiV1Routes.orders}/${orderId}/customer`
    },
    items: {
        set: (orderId) => `${ocapiV1Routes.orders}/${orderId}/items`
    },
    payments: {
        remove: (orderId, paymentId) => `${ocapiV1Routes.orders}/${orderId}/payments/${paymentId}`,
        embedded: {
            create: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/embedded`,
            getCurrent: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/embedded/current`
        },
        giftCard: {
            add: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/gift-cards`
        },
        redirect: {
            create: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/redirect`,
            getCurrent: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/redirect/current`
        },
        cinemaProcessed: {
            create: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/cinema-processed`,
            complete: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/cinema-processed`
        },
        memberBalance: {
            getMaximum: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/maximum-member-balance`,
            set: (orderId) => `${ocapiV1Routes.orders}/${orderId}/payments/member-balance`
        }
    },
    showtimes: {
        set: (orderId, showtimeId) => `${ocapiV1Routes.orders}/${orderId}/showtimes/${showtimeId}`
    },
    subscriptions: {
        set: (orderId) => `${ocapiV1Routes.orders}/${orderId}/subscription`
    },
    ticketRedemptionCards: {
        add: (orderId) => `${ocapiV1Routes.orders}/${orderId}/ticket-redemption-cards`
    },
    tip: {
        set: (orderId) => `${ocapiV1Routes.orders}/${orderId}/tip`
    },
    vouchers: {
        add: (orderId) => `${ocapiV1Routes.orders}/${orderId}/vouchers`,
        remove: (orderId, voucherId) => `${ocapiV1Routes.orders}/${orderId}/vouchers/${voucherId}`
    }
};
//# sourceMappingURL=routes.js.map